// extracted by mini-css-extract-plugin
module.exports = {"wrapperWithSidebar":"_3sGe6_8JwRvpb1asvgN6yh"};